
























import { Component, Prop, Vue } from "vue-property-decorator";
@Component({
  components: {}
})
export default class SwiperCase extends Vue {
  @Prop()
  list!: [];
  @Prop()
  jump!: string;
  url = this.$store.state.homeUrl;
  SwiperShare = {
    slidesPerView: 1,
    spaceBetween: 90,
    loop: false,
    autoplay: false,
    breakpoints: {
      //当宽度大于等于320
      320: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于480
      480: {
        slidesPerView: 1,
        spaceBetween: 0
      },
      //当宽度大于等于640
      640: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30
      },
      1000: {
        slidesPerView: 1,
        spaceBetween: 40
      },
      1200: {
        slidesPerView: 1,
        spaceBetween: 50
      },
      1366: {
        slidesPerView: 1,
        spaceBetween: 90
      }
    }
  };
  mounted() {
    //log
  }
}
